import React, { ReactNode } from "react";

import { faTimes } from "@fortawesome/pro-solid-svg-icons/faTimes";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useIntl } from "react-intl";

import { Button } from "@mapmycustomers/ui";

import styles from "./BulkApply.module.scss";

interface Props {
  label: ReactNode;
  onApply: () => void;
  onHide: () => void;
}

const BulkApply: React.FC<Props> = ({ label, onApply, onHide }) => {
  const intl = useIntl();

  return (
    <div className={styles.container}>
      <div className={styles.label}>{label}</div>
      <div>
        <Button onClick={onApply} size="small" type="primary">
          {intl.formatMessage({
            id: "map.pinLegends.styleEditor.bulkApply.apply",
            defaultMessage: "Apply",
            description: "Apply button in bulk apply component",
          })}
        </Button>
      </div>
      <div>
        <FontAwesomeIcon className={styles.close} icon={faTimes} onClick={onHide} />
      </div>
    </div>
  );
};

export default BulkApply;
